<template lang="pug">
  //- .student-attestated
  v-alert(
    color="success darken-1"
    flat
    text
    dark
  ).pa-9
    div
      .mb-8
        h1 Вы аттестованы
        .caption Текущий статус
      p Поздравляем с успешным завершением курса.
        |  Пожалуйста, дождитесь направления документа об успешном обучении

    v-card(
      color="transparent"
      light
      flat
    )
      v-divider.mb-5
      v-card-text.pa-0
        .d-flex.align-center.mb-4
          v-icon(size=55 color="secondary").mr-3 mdi-email
          strong.secondary--text Почтовые данные для отправки документа об образовании
        api-form(
          v-if="editMode"
          v-model="upkValues"
          :method="sendUpk"
          :fields="fields"
          :btn-props="{ btnText: 'Отправить' }"
          :success-callback="(resp) => setUpk(resp.data.data)"
        )
        v-list(
          color="transparent"
          v-else-if="upkSaved"
        )
          v-list-item.px-0
            v-list-item-content
              v-list-item-title Кому
              v-list-item-subtitle {{ upkSaved.whom }}
          v-list-item.px-0
            v-list-item-content
              v-list-item-title Куда
              v-list-item-subtitle
                .pre-wrap Удостоверение повышения квалификации
                  |  будет направлено по адресу "{{ upkSaved.where }}"
          v-list-item.px-0
            v-btn(
              color="secondary"
              depressed
              @click="editMode = true"
            ) Изменить
    slot(name="slot" color="success")

</template>

<script>
import HintWrap from '@/components/HintWrap.vue';

export default {
  props: {
    enrollment: { type: Object, required: true },
  },
  data: () => ({
    upkSaved: null,
    editMode: true,
    upkValues: {
      prior_record_id: null,
      whom: null,
      where: null,
    },
    fields: [
      {
        text: 'Кому',
        value: 'whom',
        component: 'v-textarea',
        component_attrs: {
          filled: true,
          rounded: true,
          rows: 1,
          'auto-grow': true,
        },
      },
      {
        text: 'Куда',
        value: 'where',
        component: HintWrap,
        component_attrs: {
          component: 'v-textarea',
          filled: true,
          rounded: true,
          rows: 1,
          'auto-grow': true,
          hintDescription: `Адрес, который мы сообщим службе "Почта России",
           в том числе индекс, для отправки удостоверения повышения квалификации`,
        },
      },
    ],
  }),
  created() {
    this.fetchUPK();
  },
  methods: {
    async fetchUPK() {
      const resp = await this.$api.enrollments.indexUPK({
        'search[prior_record_id]': this.enrollment.id,
        'search[owner_id]': this.$user.data.id,
      });
      const [upk] = resp.data.data;
      this.setUpk(upk);
    },
    setUpk(upk) {
      if (upk) {
        this.upkSaved = upk;
        Object.assign(this.upkValues, upk);
        this.editMode = false;
      }
    },
    sendUpk({ data, obs }) {
      if (this.upkSaved) {
        return this.$api.enrollments.updateUPK(this.upkSaved.id, {
          ...this.upkSaved,
          ...data,
        }, obs);
      }
      return this.$api.enrollments.createUPK({
        ...data,
        prior_record_id: this.enrollment.id,
      }, obs);
    },
  },
};
</script>
